import { RoleName } from '~/modules/adminusers/model'

export type RoleCategory = {
  name: CategoryName
  roles: RoleName[]
}

export type CategoryName = 'General' | 'Marketing' | 'CIM' | 'Service points' | 'Anders'

export const roleCategories: RoleCategory[] = [
  {
    name: 'General',
    roles: ['USERS', 'ORGANISATIONS', 'ORGANISATION_ADDRESSES', 'REPORTS'],
  },
  {
    name: 'Marketing',
    roles: ['MARKETING', 'PROMOCODES'],
  },
  {
    name: 'CIM',
    roles: ['EMAIL_STATUS', 'LABEL_REQUESTS', 'REPRINT_LABELS', 'SERVICEPOINT_VENDORS'],
  },
  { name: 'Service points', roles: ['PARCEL_SHOPS'] },
  {
    name: 'Anders',
    roles: ['ADMIN_USERS', 'TERMINALS', 'ROLES', 'CCC', 'CCC_RETURN_HUBS'],
  },
]
